<ct-dynamic-dialog
  title="Der Eingang wurde Ihnen entzogen"
  [acceptText]="backLabel()"
  [closeText]="null">
  <p><ct-shared-user-changed-message [newUser]="newUser" /></p>
</ct-dynamic-dialog>
